import Vue from 'vue';
import en from './locales/en.json';
import zh from './locales/zh.json';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const math = location.href.match(/lang=([^&]+)/);
let lang = undefined;

if (math) {
	lang = math[1];
} else {
	lang = 'zh';
}

localStorage.setItem('lang', lang);

const i18n = new VueI18n({
	locale: lang,
	messages: {
		en,
		zh
	}
});

export default i18n;
